import React, { FC } from 'react';
import { useTranslationAPI } from '../../../../translations';
import { codes } from '../../../../../data/translations/codes';
import { AngleLeftSmall } from '../../../../../components/Icons/AngleLeftSmall';
import { getPublicJobListUrl } from '../../../utils';
import RouteLink from '../../../../../components/RouteLink';

export const PublicJobDetailBackButton: FC = () => {
	const { translate } = useTranslationAPI();

	return (
		<RouteLink
			icon={<AngleLeftSmall />}
			styledButton
			link
			href={getPublicJobListUrl()}
			size='tiny'
		>
			{translate(codes.common.backToList)}
		</RouteLink>
	);
};
